import type { AnnouncementSettings, WhatsAppSettings } from '../../types';

export function normalizeAnnouncementSettings(announcementData: any): AnnouncementSettings {
    return {
        popup: {
            enabled: announcementData.announcementPopupEnabled ?? true,
            frequency: announcementData.announcementPopupFrequency ?? 'per_session',
            cooldownMinutes: announcementData.announcementPopupCooldownMinutes ?? 30,
            maxShowsPerDay: announcementData.announcementPopupMaxShowsPerDay ?? 3,
        },
        lineBar: {
            enabled: announcementData.announcementLineBarEnabled ?? true,
            dismissBehavior: announcementData.announcementLineBarDismissBehavior ?? 'hide_for_hours',
            hideDurationHours: announcementData.announcementLineBarHideDurationHours ?? 12,
        },
    };
}

export function defaultAnnouncementSettings(): AnnouncementSettings {
    return {
        popup: {
            enabled: true,
            frequency: 'per_session',
            cooldownMinutes: 30,
            maxShowsPerDay: 3,
        },
        lineBar: {
            enabled: true,
            dismissBehavior: 'hide_for_hours',
            hideDurationHours: 12,
        },
    };
}

export function normalizeWhatsappSettings(whatsappData: any): WhatsAppSettings {
    return {
        enabled: whatsappData.enabled ?? true,
        sendOrderConfirmation: whatsappData.sendOrderConfirmation ?? true,
        sendShippingUpdate: whatsappData.sendShippingUpdate ?? true,
        sendDeliveryConfirmation: whatsappData.sendDeliveryConfirmation ?? true,
        sendCancellationMessage: whatsappData.sendCancellationMessage ?? true,
        sendPaymentReminder: whatsappData.sendPaymentReminder ?? true,
        apiKeyConfigured: whatsappData.apiKeyConfigured ?? false,
        defaultDevice: whatsappData.defaultDevice ?? undefined,
        brandDeviceMap: whatsappData.brandDeviceMap ?? undefined,
        csDeviceMap: whatsappData.csDeviceMap ?? undefined,
    };
}

export function defaultWhatsappSettings(): WhatsAppSettings {
    return {
        enabled: true,
        sendOrderConfirmation: true,
        sendShippingUpdate: true,
        sendDeliveryConfirmation: true,
        sendCancellationMessage: true,
        sendPaymentReminder: true,
        apiKeyConfigured: false,
        defaultDevice: undefined,
        brandDeviceMap: undefined,
        csDeviceMap: undefined,
    };
}
